<div class="flex w-full h-full gap-8">
  @if (androidScreenshot$ | async) {
    <div class="w-fit mb-6 screenshot-container">
      <svg
        class="w-full h-full"
        viewBox="0 0 286 616"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <clipPath id="android-phone-clip">
            <rect x="8" y="8" width="270" height="600" rx="40" />
          </clipPath>
        </defs>
        <rect
          x="4"
          y="4"
          width="278"
          height="608"
          rx="44"
          stroke="black"
          stroke-width="8"
        />
        <image
          [attr.xlink:href]="androidScreenshot$ | async"
          x="8"
          y="8"
          width="270"
          height="600"
          preserveAspectRatio="xMidYMid slice"
          clip-path="url(#android-phone-clip)"
        />
        <circle cx="143" cy="22" r="6" fill="black" />
      </svg>
    </div>
  }
  <div class="flex-2 h-full w-full flex flex-col justify-center pb-6">
    <h3 class="text-2xl font-bold mb-[10px]">
      {{ 'android-screenshot.title' | translate }}
    </h3>

    <p
      class="opacity-70 mb-[10px]"
      [innerHTML]="'android-screenshot.desc' | translate"
    ></p>
    @if (playStoreLink$ | async; as link) {
      <rk-button
        (buttonClick)="window.open(link, '_blank')"
        [text]="'global.share' | translate"
      ></rk-button>
    }
  </div>
</div>
